<template>
  <v-container class="facility-info p-0" v-if="facilityType" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>

    <HkiaraceBannerFrame :src="host + 'static/'+facilityType.banner"
                         :label="facilityType.name.toUpperCase()"
                         no-parallax
                         no-transform-content>
      <div class="facility-info-details">
        <HkiaraceCardDisplayFrame :image-src="host + 'static/' + facilityPhotoSlides[0]">
          <template slot="sub-title">
            {{ $t('header.facility') }}
          </template>
          <template slot="title">
            {{ facilityType.name }}
          </template>
          <template slot="action">
            <div class="facility-info-congestion-status" v-if="facilityType.acc_congestion_status !== -1">
              {{ $t('facility_congestion_status.title') + $t('facility_congestion_status.' + facilityType.acc_congestion_status) }}
            </div>
            <div class="" v-if="facilityType.open_for_booking">
              <v-btn class="function-button" color="primary" rounded @click="reserveFacility">
                <v-icon>mdi-calendar-check</v-icon>
                {{ $t('facility.reserve_now') }}
              </v-btn>
            </div>
            <div v-if="facilityType.is_acc_gym">
              <div v-if="!haveValidPass">
                <v-btn v-for="subType in subscriptionTypes" v-bind:key="subType.id" class="function-button" color="primary" rounded @click="buyGymPass(subType)">
                  {{ $t('facility.buy') }} {{ subType.name }}
                </v-btn>
              </div>
              <div v-else>
                <v-btn class="function-button" color="primary" rounded @click="reserveGym"
                       v-if="validPass && validPass.type.can_reserve">
                  <v-icon>mdi-calendar-check</v-icon>
                  {{ $t('facility.reserve_now') }}
                </v-btn>
                <v-btn v-else
                       class="function-button" color="primary" rounded disabled>
                  {{ $t('facility.bought_one_time_pass') }}
                </v-btn>
                <!--                <v-btn class="function-button" color="primary"-->
                <!--                       :to="{name: 'my-account', query: {t: 3}}">-->
                <!--                  {{ $t('facility.view') }}-->
                <!--                </v-btn>-->
              </div>
            </div>
          </template>
          <template slot="gym-availability"
                    v-if="facilityType.is_acc_gym">
            <div class="gym-availability-wrapper">
              <v-row>
                <v-col class="gym-availability-date">
                  {{ $parseDate(new Date().toISOString(), 'yyyy-MM-dd') }}
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-progress-circular size="180"
                                       width="10"
                                       :value="gymBookingPercentage"
                                       :color="gymBookingColor"
                                       rotate="-90">
                    <template #default>
                      <v-container fluid
                                   class="gym-availability-container">
                        <div class="gym-availability-title">
                          {{ $t('gym_booking.availability') }}
                        </div>
                        <div class="gym-availability-count">
                          {{ gymBookingAvailableCount }} <span class="max-count">/{{ gymBookingMaxCount }}</span>
                        </div>
                        <v-chip rounded
                                dark
                                :color="gymBookingColor"
                                small>{{ gymBookingStatus }}
                        </v-chip>
                      </v-container>
                    </template>
                  </v-progress-circular>
                </v-col>
              </v-row>
            </div>
          </template>
          <template slot="content">
            <div class="facility-info-detail-content">
              <div class="facility-info-detail-description" v-html="facilityType.description">
              </div>
            </div>
            <!--<iframe :srcdoc="facilityType.description">-->
            <!--</iframe>-->

          </template>
        </HkiaraceCardDisplayFrame>
      </div>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import _ from 'lodash';
import {DateTime} from 'luxon';
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import HkiaraceCardDisplayFrame from "../../../components/HkiaraceCardDisplayFrame";

import {HOST} from '@/main'
import {computed, onMounted, ref, watch} from "@vue/composition-api";

export default {
  name: 'FacilityInfo',
  components: {HkiaraceBannerFrame, HkiaraceCardDisplayFrame},
  setup(props, {root}) {
    const isLoggedIn = computed(() => !!root.$store.state.user.id);
    const isAccMembershipValid = function () {
      if (!root.$store.state.user.acc_membership_valid_until) return false;

      let validUntil = DateTime.fromISO(root.$store.state.user.acc_membership_valid_until);

      return validUntil.invalid === null && DateTime.fromJSDate(new Date()) < validUntil;
    }

    const facilityTypeId = computed(() => root.$route.params.facilityTypeId);
    watch(() => facilityTypeId.value, () => {
      getFacilityType();
    });
    const facilityType = ref(null);
    const facilityPhotoSlides = computed(() => {
      let photos = [];
      try {
        photos = JSON.parse(facilityType.value.photos);
      } catch (e) {
        alert(e)
      }
      return photos;
    })
    const getFacilityType = function () {
      root.$callAPI('aafb/facility_types/', {type_id: facilityTypeId.value}, function (response) {
        facilityType.value = response.body.item_type;

        if (facilityType.value.is_acc_gym) {
          getSubscriptionTypes()
          getGymBookingStatus();
        }
      });
    };
    const reserveFacility = function () {
      if (isLoggedIn.value) {
        if (isAccMembershipValid()) {
          root.$router.push({name: 'facility-reserve', params: {itemTypeId: facilityType.value.id}});
        } else {
          root.$showAlertMessage(root.$t('error_messages.acc_not_activated'), () => {
            root.$router.push({name: 'my-account'});
          });
        }
      } else {
        root.$showAlertMessage(root.$t('login_msg'), () => {
          root.$router.push({name: 'login', query: {after: root.$route.path}})
        })
      }
    }

    const subscriptionTypes = ref(null);
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = response.body.subscription_types;
      });
    }
    const buyGymPass = async function (type) {
      if (isLoggedIn.value) {
        if (isAccMembershipValid()) {
          if (type.can_reserve || await root.$dialog.confirm({
            text: root.$t('gym_subscription.confirm_day_pass_msg'),
            showCancel: false,
          })) {
            root.$callAPI('aafb/gym_subscription/create/', {type_id: type.id}, function (response) {
              root.$router.push({name: 'gym-pass-preview', params: {subscriptionId: response.body.subscription_id}});
            });
          }
        } else {
          root.$showAlertMessage(root.$t('error_messages.acc_not_activated'), () => {
            root.$router.push({name: 'my-account'});
          });
        }
      } else {
        root.$showAlertMessage(root.$t('login_msg'), () => {
          root.$router.push({name: 'login', query: {after: root.$route.path}})
        })
      }
    };
    const subscriptions = ref([]);
    const getSubscription = function () {
      root.$callAPI('aafb/gym_subscription/', {}, function (response) {
        subscriptions.value = response.body.subscriptions;
      })
    }
    const validPass = computed(() => {
      return _.find(subscriptions.value, (s) => {
        return s.status === 1 && DateTime.fromISO(s.valid_until).toJSDate() > new Date();
      })
    })
    const haveValidPass = computed(() => {
      return _.some(subscriptions.value, (s) => {
        return s.status === 1 && DateTime.fromISO(s.valid_until).toJSDate() > new Date();
      })
    })

    const gymBookingAvailableCount = ref(0);
    const gymBookingMaxCount = ref(1);
    const gymBookingPercentage = computed(() => Math.floor((gymBookingMaxCount.value - gymBookingAvailableCount.value) / gymBookingMaxCount.value * 100))
    const gymBookingColor = computed(() => {
      if (gymBookingAvailableCount.value === 0) {
        return 'red';
      }
      if (gymBookingPercentage.value >= 75) {
        return 'rgb(225,184,93)';
      }

      return 'rgb(178,216,210)';
    });
    const gymBookingStatus = computed(() => {
      if (gymBookingAvailableCount.value === 0) {
        return root.$t('gym_booking.full');
      }
      if (gymBookingPercentage.value >= 75) {
        return root.$t('gym_booking.almost_full');
      }

      return root.$t('gym_booking.available');
    })
    const getGymBookingStatus = function () {
      root.$callAPI('aafb/gym_booking/status/', {today: true}, (response) => {
        gymBookingMaxCount.value = response.body.max;
        gymBookingAvailableCount.value = Math.max(gymBookingMaxCount.value - (response.body.counts.length > 0 ? response.body.counts[0].count : 0) + response.body.today_offset, 0);
      });
    }
    const reserveGym = function () {
      if (isAccMembershipValid()) {
        root.$router.push({name: 'gym-reserve'});
      } else {
        root.$showAlertMessage(root.$t('error_messages.acc_not_activated'), () => {
          root.$router.push({name: 'my-account'});
        });
      }
    }

    onMounted(() => {
      getFacilityType();
    })

    watch(() => isLoggedIn.value, (newValue) => {
      if (newValue) {
        getSubscription();
      }
    }, {immediate: true})

    return {
      facilityTypeId,
      facilityType,
      facilityPhotoSlides,
      reserveFacility,

      subscriptionTypes,
      buyGymPass,
      subscriptions,
      validPass,
      haveValidPass,

      gymBookingAvailableCount,
      gymBookingMaxCount,
      gymBookingPercentage,
      gymBookingColor,
      gymBookingStatus,
      reserveGym,

      host: HOST,
    }
  },
}
</script>

<style lang="less">
.facility-info {
  .function-button {
    margin-top: 26px;
    margin-bottom: 12px;
    margin-right: 10px;
  }

  .facility-info-details {
    background-color: white;

    .gym-availability-wrapper {
      width: 180px;
      //border-left: 1px solid #d0bda9;
      display: inline-block;
      text-align: left;
      padding-left: 12px;
    }

    .gym-availability-date {
      font-size: 0.9rem;
      color: rgba(105, 103, 103, 0.8);
    }

    .gym-availability-container {
      text-align: center;
      padding: 30px;

      label {
        margin-bottom: 0;
      }

      .gym-availability-title {
        font-size: 1rem;
        line-height: 1.2rem;
        color: rgba(105, 103, 103, 0.8);
      }

      .gym-availability-count {
        font-size: 3rem;
        line-height: 3rem;
        color: rgba(105, 103, 103, 0.8);

        .max-count {
          font-size: 0.7rem;
        }
      }
    }

    .facility-info-detail-content {
      line-height: 1.5;

      p {
        margin-bottom: 6px;
      }

      td {
        vertical-align: text-top;
        min-width: 20px;
        padding-right: 5px;
      }

      // height: 100%;
      // background-color: white;
      // padding: 4rem 8rem 4rem 2rem;

      // .facility-info-detail-sub-title {
      //     color: #8c8c8c;
      // }

      .facility-info-detail-description {
        color: #8c8c8c;
      }
    }
  }
}
</style>
